export const clickableText =
  'cursor-pointer text-blue-600 hover:text-blue-700 underline underline-offset-2'
